import { createContext } from 'react'
import type { GlobalDatePreset } from '../lib/datePresets'

export type { GlobalDatePreset }

export interface GlobalDateRange {
  startDate: string
  endDate: string
  preset: GlobalDatePreset | null
}

export interface GlobalDateContextValue {
  dateRange: GlobalDateRange
  setDateRange: (range: GlobalDateRange) => void
}

export const GlobalDateContext = createContext<GlobalDateContextValue | null>(null)
